import { createFileRoute } from "@tanstack/react-router";
import { ProductPage, buildProductHead } from "@/components/shop/ProductPage";
import { blackPvcDict } from "@/lib/shop/products/black-pvc";
import { alternateLinkList } from "@/lib/i18n/locale";

export const Route = createFileRoute("/shop_/black-pvc")({
  head: () => ({
    ...buildProductHead(blackPvcDict),
    links: alternateLinkList("/shop/black-pvc", "en"),
  }),
  component: () => <ProductPage dict={blackPvcDict} />,
});